<template>
  <el-popover
    ref="popover"
    popper-class="detail-pop"
    placement="bottom-start"
    :title="title"
    width="300"
    trigger="hover"
  >
    <div style="text-indent: 2em;" v-html="content"></div>
    <img
      slot="reference"
      :style="'cursor:pointer;width:20px;margin-left:10px;vertical-align:middle'"
      src="static/img/icon/tips.png"
      alt
      class="img"
    />
  </el-popover>
</template>
<script>
export default {
  name: "m-tips",
  props: {
    title: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  }
};
</script>


// WEBPACK FOOTER //
// src/components/m-tips/m-tips.vue